import { MaterialModule } from './../../../../core/shared/util/material/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageViewComponent } from './image-view.component';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { ProgressModule } from 'src/app/features/components/progress/progress.module';
import { ImageEditorModalModule } from '../../modals/image-editor-modal/image-editor-modal.module';
import { ImagePreloadModule } from 'src/app/core/directives/image-preload/image-preload.module';
@NgModule({
  declarations: [ImageViewComponent],
  imports: [CommonModule, MaterialModule, AngularFireStorageModule, ProgressModule, ImageEditorModalModule, ImagePreloadModule],
  exports: [ImageViewComponent]
})
export class ImageViewModule { }
